import { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Modal } from "bootstrap";
import ReactDOM from "react-dom";
import $ from "jquery";
import { AutoCompleteSearchBox } from "../../View/algolia/autoCompleteSearchBox";
import { AutoCompleteSearchBoxMobile } from "../../View/algolia/autoCompleteSearchBoxMobile";
import { useGuestLoginPrompt } from "../../Context/hook/useGuestClickGuard";
export const SearchSuggestionMobile = () => {
  const promptLogin = useGuestLoginPrompt();
  const [SearchTxt, setSearchTxt] = useState("");
  const [popupRef, setPopupRef] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const { srctxt } = useParams();

  useEffect(() => {
    if (srctxt) setSearchTxt(String(srctxt).trim());
    const targetDiv = document.querySelector(".mobile-view search-suggestions");

    if (targetDiv) {
      const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
          if (mutation.type == "attributes" && mutation.attributeName == "style") {
            const isVisible = window.getComputedStyle(targetDiv).display != "none";
            if (isVisible) {
              setIsOpen(true);
            } else {
              setIsOpen(false);
            }
          }
        });
      });

      observer.observe(targetDiv, { attributes: true });
    }
  }, [srctxt]);

  useEffect(() => {
    handleHide();
  }, [window.location.href]);

  const handleShow = () => {
    if (promptLogin()) return;
    $(".mobile-view.search-suggestions").fadeIn("slow");
    $(".search-backdrop").addClass("search-bg");
    $("body").addClass("search-body");
    setIsOpen(true);
  };

  const handleHide = () => {
    $(".mobile-view.search-suggestions").fadeOut("slow");
    $(".search-backdrop").removeClass("search-bg");
    $("body").removeClass("search-body");
    setIsOpen(false);
  };

  return (
    <Fragment>
      <div className="mob-search position-relative d-block d-lg-none">
        <span className="wes-search header-search-form" onClick={handleShow} />
      </div>
      <div className="mobile-view search-suggestions">
        <div className="container-fluid p-0">
          <AutoCompleteSearchBoxMobile isOpen={isOpen} handleHide={handleHide} />
        </div>
      </div>
    </Fragment>
  );
};
